// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1A5bz","checkboxCol":"Table_checkboxCol__2AxUZ","emailCol":"Table_emailCol__2E3Gj","actionCol":"Table_actionCol__2Xy3-"};